import Storage from "./storage.service";
import Helpers from "../helpers/shared.helper";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import HTTP from "./http.service";

var User = {};
User.session = "";
User.device_id = null;
User.flow_status_flags = null;
User.reservation_type = 1;

var obsrv = new BehaviorSubject(User.session);
obsrv.next(User.session);
User.get_session = function (setting) {
	return obsrv.asObservable();
};

User.init = () => {
	if (
		window.localStorage.getItem("session") &&
		window.localStorage.getItem("device_id")
	) {
		Storage.set("session", window.localStorage.getItem("session"));
		Storage.set("device_id", window.localStorage.getItem("device_id"));
		HTTP.set_device_id(Storage.get("device_id"));
		HTTP.set_session(Storage.get("session"));
	} else {
		window.localStorage.removeItem("session");
		window.localStorage.removeItem("device_id");
	}
	User.checkUser();
};

User.submitContact = (UserData) => {
	let config = {
		method: "post",
		url: "/me/submit_customer_contact",
		data: UserData,
		headers: {
			"cache-control": "no-cache"
		}
	};
	return HTTP(config);
}
User.getOTP = (number) => {
	let config = {
		method: "post",
		url: "/activation/send_activation_otp",
		data: number,
		headers: {
			"cache-control": "no-cache"
		}
	};
	return HTTP(config);
}
User.fetchSummary = number => {
	let config = {
		method: "get",
		url: "/me/summary",
		number: number
	};
	return HTTP(config);
};

User.isDone = (flags = null) => {
	flags = flags || Storage.get("flags");
	let done =
		(flags.SIMActivated ||
			flags.SIMDelivered ||
			flags.DeliveryInProgress) &&
		!flags.IsCustomerAssisted;
	return done;
};

User.isLoggedInProper = () => {
	let flags = Storage.get("flags");
	return Storage.get("session") && flags && flags.IsLoggedInViaEmail
		? true
		: false;
};

User.isLoggedIn = () => {
	return Storage.get("session") ? true : false;
};

User.goToStatusRoute = () => {
	User.fetchFlowStatus(9);
};

User.fetchFlowStatus = callee => {
	if (!User.fetching) {
		User.fetching = true;
		const streamModal = Storage.get("StreamModal");
		return User.getFlowStatus()
			.then(response => {
					let flags = response.data.flow_status_flags;
					flags["CanSearch"] = !flags.IsPlanPaid || !flags.NumberSelected;
					if (response.data.flow_status_flags.NumberPaymentPending || !response.data.flow_status_flags.IsPlanPaid) {
						flags["PaymentPending"] = true;
					}

					if (response.data.flow_status_flags?.AbsherTokenIsValid) {
						flags["absher_fulfilled"] = true;
					}

					if (response.data.flow_status_flags?.SimAttached || response.data.flow_status_flags?.choose_need_sim) {
						flags["isSimSelected"] = true;
					}
					
					if (Storage.get("choose_bill_payment", true)) {
						flags["choose_bill_payment"] = true;
						Storage.clear("featureLoading");
					}

					flags["web_number_status"] = true;

					if (Storage.get("choose_sim_deactivation", true)) {
						flags["choose_sim_deactivation"] = true;
						Storage.clear("featureLoading");
					}
					
					if (Storage.get("is_web_category_selected", true)) {
						flags["is_web_category_selected"] = true;
					}
					if (Storage.get("choose_plan_category", true)) {
						flags["choose_plan_category"] = true;
					}
					if (Storage.get("TopNumberAdded", true)) {
						flags["TopNumberAdded"] = true;
					}
					if (Storage.get("choose_topup_category", true)) {
						flags["choose_topup_category"] = true;
					}
					if (Storage.get("topPaymentFailed", true)) {
						flags["topPaymentFailed"] = true;
					}
					if (Storage.get("topPaymentDone", true)) {
						flags["topPaymentDone"] = true;
					}

					if (Storage.get("deliverInprogress", true)) {
						flags["is_delivery_in_progress"] = true;
					}
					if (Storage.get("user_data_submitted", true)) {
						flags["UserContactSubmitted"] = true;
					}

					if (Storage.get("selfieSubmitted", true)) {
						flags["selfie_submitted"] = true;
					}

					if (Storage.get("eligible_update_info", true)) {
						flags["OCRSubmitted"] = false;
						flags["AddressSubmitted"] = false;
					}
					if (Storage.get("check_eligible", true)) {
						flags["is_eligible"] = true;
					}
					if (flags["NumberSelected"] === false) {
						Storage.clear("web_random_number_skip");
					}

					if (flags["NumberSelected"] === true) {
						flags["is_web_category_selected"] = true;
					}

					if (Storage.get("eligible_update_mnp", true)) {
						flags["choose_random_number"] = false;
						flags["choose_mnp"] = true;
					}
					if (Storage.get("recalled_delivery", true)) {
						flags["SIMDelivered"] = false;
						flags["DeliveryInProgress"] = false;
					}
					if (Storage.get("eligibility_fulfilled", true)) {
						flags["IsEligible"] = true;
					}

					if (flags["SIMDelivered"] || flags["IsDeliveryRequested"]) {
						Storage.clear('web_delivery_required');
					}

					if (flags["IsPlanPaid"]) {
						Storage.clear('web_payment_required');
					}
					if (Storage.get("sim_delivered_claim", true)) {
						flags["SIMDelivered"] = true;
						flags["DeliveryInProgress"] = false;
					}

					if (Storage.get("activation_retry", true)) {
						flags["activation_retry"] = true;
					}

					User.fetching = false;

					if (User.isDone(flags)) {
						Storage.set("flags", flags);
					} else {
						Storage.set("flags", flags);
					}

					if (streamModal) {
						if (streamModal?.type === 'STORAGE_PARAMS_CUS' || streamModal?.type === "STORAGE_PARAMS_PRD_PLAN_IDs")
							Storage.set("StreamModal", {});
					}

			})
			.catch(error => {
				User.fetching = false;
				if (streamModal) {
					if (streamModal?.type === 'STORAGE_PARAMS_CUS' || streamModal?.type === "STORAGE_PARAMS_PRD_PLAN_IDs")
						Storage.set("StreamModal", {});
				}
			});
	}
};

User.checkUser = () => {
	if (!User.isLoggedIn()) {
		Storage.clear("terms_confirmed");
		Storage.clear("pay_on_delivery");
		Storage.set("securityManagementLoading", true);
		User.loginByDeviceID()
			.then(response => {
				HTTP.set_session(response.data.SessionID ? response.data.SessionID : response.data.session_id);
				Storage.set("device_id", HTTP.get_device_id(), true);
				Storage.set("session", response.data.SessionID ? response.data.SessionID : response.data.session_id, true);
				Storage.set("uid", response.data.profile.uid, true);
				Storage.set("securityManagementLoading", false);
			})
			.catch(error => {
				Storage.set("securityManagementLoading", false);
			});
	}
};

User.clear = function () {
	var rand = Helpers.generateDeviceID();
	User.device_id = rand;
	HTTP.defaults.headers.common["Virgin-Device-Id"] = rand;
	window.localStorage.setItem("device_id", User.device_id);
	window.localStorage.removeItem("session_email");
};

User.logout = function (newUser = false) {
	Helpers.log("logout()");
	HTTP.set_session("");

	Storage.clear("session");
	Storage.clear("device_id");
	Storage.clear("flags");
	Storage.clear("terms_confirmed");
	Storage.clear("pay_on_delivery");

	if (window.FB) {
		window.FB.getLoginStatus(function (response) {
			if (response.status === "connected") {
				window.FB.logout();
			}
		});
	}

	if (window.gapi && window.gapi.auth2) {
		var auth2 = window.gapi.auth2.getAuthInstance();
		if (auth2.isSignedIn.get()) {
			auth2.signOut();
		}
	}
};

User.logoutKWNumberBooking = function (newUser = false) {
	window.localStorage.clear("user_selection");
	window.localStorage.clear("session");
	window.localStorage.clear("device_id");
	window.localStorage.clear("terms_confirmed")
};

User.login = function (UserData) {

	let config = {
		method: "post",
		url: "/securitymanagement/login",
		data: UserData
	};
	return HTTP(config);
};

User.check_email = function (UserData) {
	let config = {
		method: "post",
		url: "/securitymanagement/check",
		data: UserData
	};
	return HTTP(config);
};

User.setPassword = function (UserData) {
	let config = {
		method: "post",
		url: "/securitymanagement/set_password",
		data: UserData
	};

	return HTTP(config);
};

User.getSummary = () => {
	Helpers.log("User.login_by_device_id()");
	let config = {
		method: "post",
		url: "/me/summary"
	};
	return HTTP(config);
};

User.social_login = data => {
	Helpers.log("User.login_by_device_id()");
	let config = {
		method: "post",
		url: "/securitymanagement/social_login",
		data: data
	};
	return HTTP(config);
};

User.loginByDeviceID = () => {
	Helpers.log("User.login_by_device_id()");
	let config = {
		method: "post",
		url: "/securitymanagement/login_by_device_id"
	};
	return HTTP(config);
};

User.updateFlowStatus = (key, value) => {
	Helpers.log("User.updateFlowStatus()");
	let config = {
		method: "post",
		url: "/me/flow_status",
		data: {
			key: key,
			value: value
		}
	};
	return HTTP(config);
};

User.getFlowStatus = () => {
	let config = {
		method: "get",
		url: "/me/flow_status"
	};
	return HTTP(config);
};

export default User;